import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import { analyticsTrack } from '../../../analyticsUtils';
import { putRequest } from '../../../requestUtils';
import ProjectLoadingIndicator from '../ProjectLoadingIndicator';
import './ProjectExpertisePriority.scss';
import '../ProjectDetails.scss';
import lineImg from '../../../../assets/images/must-haves-line.svg';
import listImg from '../../../../assets/images/must-haves-list.svg';
var models = ['area_of_expertise', 'therapeutic_area', 'disease_code', 'therapy', 'regulatory_pathway', 'development_phase', 'degree', 'language', 'skill', 'accreditation'];
var formStep = 'expertise-priority';
var ProjectExpertisePriority = /*#__PURE__*/function (_Component) {
  function ProjectExpertisePriority(props) {
    var _this;
    _classCallCheck(this, ProjectExpertisePriority);
    _this = _callSuper(this, ProjectExpertisePriority, [props]);
    _defineProperty(_this, "applySuggestionsIfAny", function () {
      var suggestedTagLabels = _this.props.suggestedTagLabels;
      var _this$state = _this.state,
        nonPriorityExpertiseTags = _this$state.nonPriorityExpertiseTags,
        expertisePicklists = _this$state.expertisePicklists,
        notApplicable = _this$state.notApplicable;
      if (!suggestedTagLabels || !expertisePicklists || !nonPriorityExpertiseTags) return;
      var updated = _objectSpread({}, nonPriorityExpertiseTags);
      var labelToId = function labelToId(model, label) {
        var pick = (expertisePicklists[model] || []).find(function (opt) {
          return opt.label === label;
        });
        return pick ? pick.value : null;
      };
      Object.keys(suggestedTagLabels).forEach(function (model) {
        var labels = suggestedTagLabels[model];
        if (!labels || notApplicable.includes(model)) return;
        var ids = labels.map(function (l) {
          return labelToId(model, l);
        }).filter(function (v) {
          return v !== null;
        });
        if (ids.length === 0) return;
        var current = Array.isArray(updated["".concat(model, "_ids")]) ? updated["".concat(model, "_ids")] : [];
        updated["".concat(model, "_ids")] = Array.from(new Set([].concat(_toConsumableArray(current || []), _toConsumableArray(ids))));
      });
      _this.setState({
        nonPriorityExpertiseTags: updated
      });
    });
    _this.state = {
      showModal: false,
      errors: null,
      expertiseTags: null,
      nonPriorityExpertiseTags: null,
      priorityExpertiseTags: null,
      expertisePicklists: null,
      notApplicable: []
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleBack = _this.handleBack.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handlePromote = _this.handlePromote.bind(_this);
    _this.handleDemote = _this.handleDemote.bind(_this);
    _this.handleClear = _this.handleClear.bind(_this);
    return _this;
  }
  _inherits(ProjectExpertisePriority, _Component);
  return _createClass(ProjectExpertisePriority, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        getProjectDetails = _this$props.getProjectDetails;
      if (!projectResourceId) return;
      getProjectDetails(formStep).then(function (response) {
        _this2.setState({
          expertiseTags: response.data.expertise_tags,
          expertisePicklists: response.data.expertise_picklists,
          priorityExpertiseTags: response.data.priority_expertise_tags,
          nonPriorityExpertiseTags: response.data.non_priority_expertise_tags,
          notApplicable: response.data.not_applicable
        }, _this2.applySuggestionsIfAny);
      });
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      if (this.props.formType === 'page') {
        this.props.back();
      } else {
        this.handleHideModal();
      }
    }
  }, {
    key: "ableToSubmit",
    value: function ableToSubmit() {
      var priorityExpertiseTags = this.state.priorityExpertiseTags;
      var alltags = [];
      models.forEach(function (model) {
        alltags = [].concat(_toConsumableArray(alltags), _toConsumableArray(priorityExpertiseTags["".concat(model, "_ids")]));
      });
      return alltags.length > 0;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        projectResourceId = _this$props2.projectResourceId,
        afterSubmit = _this$props2.afterSubmit;
      var _this$state2 = this.state,
        priorityExpertiseTags = _this$state2.priorityExpertiseTags,
        nonPriorityExpertiseTags = _this$state2.nonPriorityExpertiseTags;
      var projectAttributes = {};
      models.forEach(function (model) {
        // exclude priority tags from non-prefixed list so Rails will delete them and re-add them
        projectAttributes["non_priority_".concat(model, "_ids")] = nonPriorityExpertiseTags["".concat(model, "_ids")];
        projectAttributes["priority_".concat(model, "_ids")] = priorityExpertiseTags["".concat(model, "_ids")];
      });
      putRequest("/projects/".concat(projectResourceId, "?form_step=expertise-priority"), {
        project: projectAttributes
      }, csrfToken).then(function () {
        afterSubmit();
      })["catch"](function (error) {
        _this3.setState({
          errors: error.name
        });
        return null;
      });
    }
  }, {
    key: "handlePromote",
    value: function handlePromote(e) {
      var _this$state3 = this.state,
        nonPriorityExpertiseTags = _this$state3.nonPriorityExpertiseTags,
        priorityExpertiseTags = _this$state3.priorityExpertiseTags;
      var model = e.target.dataset.model;
      var label = e.target.dataset.label;
      var priorityTags = priorityExpertiseTags;
      var selectedTag = Number(e.target.dataset.id);
      if (priorityTags["".concat(model, "_ids")].includes(selectedTag)) {
        return;
      }
      priorityTags["".concat(model, "_ids")].push(selectedTag);
      var nonPriorityTags = nonPriorityExpertiseTags;
      var foundIndex = nonPriorityTags["".concat(model, "_ids")].findIndex(function (i) {
        return i === Number(e.target.dataset.id);
      });
      nonPriorityTags["".concat(model, "_ids")].splice(foundIndex, 1);
      analyticsTrack("Promoted ".concat(label, " to Must-have expertise"), {
        location: 'Project creation'
      });
      this.setState({
        priorityExpertiseTags: priorityTags,
        nonPriorityExpertiseTags: nonPriorityTags
      });
    }
  }, {
    key: "handleDemote",
    value: function handleDemote(e) {
      var _this$state4 = this.state,
        nonPriorityExpertiseTags = _this$state4.nonPriorityExpertiseTags,
        priorityExpertiseTags = _this$state4.priorityExpertiseTags;
      var model = e.target.dataset.model;
      var label = e.target.dataset.label;
      var priorityTags = priorityExpertiseTags;
      var foundIndex = priorityTags["".concat(model, "_ids")].findIndex(function (i) {
        return i === Number(e.target.dataset.id);
      });
      priorityTags["".concat(model, "_ids")].splice(foundIndex, 1);
      var nonPriorityTags = nonPriorityExpertiseTags;
      nonPriorityTags["".concat(model, "_ids")].push(Number(e.target.dataset.id));
      analyticsTrack("Demoted ".concat(label, " from Must-have expertise"), {
        location: 'Project creation'
      });
      this.setState({
        priorityExpertiseTags: priorityTags,
        nonPriorityExpertiseTags: nonPriorityTags
      });
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      var _this$state5 = this.state,
        priorityExpertiseTags = _this$state5.priorityExpertiseTags,
        expertiseTags = _this$state5.expertiseTags;
      var priorityTags = priorityExpertiseTags;
      // TODO: remove eslint disabled line

      var resetTags = structuredClone(expertiseTags);
      models.forEach(function (model) {
        priorityTags["".concat(model, "_ids")] = [];
      });
      this.setState({
        priorityExpertiseTags: priorityTags,
        nonPriorityExpertiseTags: resetTags
      });
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.handleHideModal,
        dialogClassName: "expertise-priority-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "expertise-priority-modal-body"
      }, this.renderContent()));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props3 = this.props,
        backButtonText = _this$props3.backButtonText,
        submitButtonText = _this$props3.submitButtonText;
      return /*#__PURE__*/React.createElement("div", {
        className: "footer-buttons-container mt-4"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleBack
      }, backButtonText), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit",
        onClick: this.handleSubmit,
        disabled: !this.ableToSubmit()
      }, submitButtonText));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.state.errors;
      return errors && /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, /*#__PURE__*/React.createElement("h3", null, "Errors prohibited this project from being saved:"), /*#__PURE__*/React.createElement("ul", null, errors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", null, e);
      })));
    }
  }, {
    key: "renderPriorityBadges",
    value: function renderPriorityBadges() {
      var _this4 = this;
      var priorityExpertiseTags = this.state.priorityExpertiseTags;
      var className2 = 'tag-container-flex';
      return /*#__PURE__*/React.createElement("div", {
        className: className2
      }, models.map(function (model) {
        return priorityExpertiseTags["".concat(model, "_ids")].map(function (id) {
          return _this4.renderBadge(model, id, true);
        });
      }));
    }
  }, {
    key: "renderBadges",
    value: function renderBadges(subheading, model) {
      var _this5 = this;
      var _this$state6 = this.state,
        expertiseTags = _this$state6.expertiseTags,
        notApplicable = _this$state6.notApplicable;
      var tagIds = expertiseTags["".concat(model, "_ids")] || [];
      var shouldRenderCategory = !notApplicable.includes(model) && tagIds.length > 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "tag-container ".concat(model)
      }, /*#__PURE__*/React.createElement("div", {
        className: "expertise-tag-dropdown-heading"
      }, subheading), /*#__PURE__*/React.createElement("div", {
        className: "tag-container-flex"
      }, shouldRenderCategory ? tagIds.map(function (id) {
        return _this5.renderBadge(model, id, false);
      }) : /*#__PURE__*/React.createElement("p", null, "None Selected")));
    }
  }, {
    key: "renderBadge",
    value: function renderBadge(model, id, priority) {
      var _this$state7 = this.state,
        expertisePicklists = _this$state7.expertisePicklists,
        priorityExpertiseTags = _this$state7.priorityExpertiseTags;
      var picklistTag = expertisePicklists[model].find(function (tag) {
        return tag.value === id;
      });
      var label = picklistTag && picklistTag.label;
      var selected = priorityExpertiseTags["".concat(model, "_ids")].includes(id);
      var demoteSymbol = priority ? 'fa-xmark fa-solid right' : 'fa-solid fa-check left';
      var symbolClass = selected ? "fas ".concat(demoteSymbol) : 'fas fa-plus left';
      var badgeStyleClass = selected ? 'qualification-tag must-haves-tag' : 'expertise-tag-button';
      var action = selected ? this.handleDemote : this.handlePromote;
      if (!label) return null;
      return /*#__PURE__*/React.createElement("span", {
        onClick: action,
        "data-model": model,
        "data-label": label,
        "data-id": id,
        key: id,
        className: badgeStyleClass,
        role: "button",
        tabIndex: 0
      }, priority ? /*#__PURE__*/React.createElement(Fragment, null, label, "\xA0", /*#__PURE__*/React.createElement("i", {
        "data-model": model,
        "data-label": label,
        "data-id": id,
        className: symbolClass
      })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("i", {
        "data-model": model,
        "data-label": label,
        "data-id": id,
        className: symbolClass
      }), "\xA0", label));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var expertiseTags = this.state.expertiseTags;
      if (!expertiseTags) {
        return /*#__PURE__*/React.createElement(ProjectLoadingIndicator, null);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-expertise-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6 expertise-entry-container expertise-priority"
      }, this.renderErrors(), /*#__PURE__*/React.createElement("h2", null, "Must-Have Qualifications"), /*#__PURE__*/React.createElement("p", null, "Select the requirements that candidates must have. You will only receive proposals from candidates who meet all your must-have requirements."), /*#__PURE__*/React.createElement("br", null), this.renderBadges('Functional Areas', 'area_of_expertise'), this.renderBadges('Therapeutic Areas', 'therapeutic_area'), this.renderBadges('Diseases and Indications', 'disease_code'), this.renderBadges('Product Technologies', 'therapy'), this.renderBadges('Regulatory Pathways', 'regulatory_pathway'), this.renderBadges('Development Phases', 'development_phase'), this.renderBadges('Other Keywords / Skills', 'skill'), this.renderBadges('Language', 'language'), this.renderBadges('Highest Education', 'degree'), this.renderBadges('Certification', 'accreditation'), !this.ableToSubmit() && /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, "Select at least 1 must-have"), this.renderButtons()), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-3 protip-container must-haves"
      }, /*#__PURE__*/React.createElement(SVG, {
        src: listImg,
        title: "Must have list"
      }), /*#__PURE__*/React.createElement("div", {
        className: "must-haves-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "must-haves-title"
      }, "Must-Have List"), /*#__PURE__*/React.createElement("span", {
        role: "button",
        className: "btn",
        tabIndex: 0,
        style: {
          outline: 0
        },
        onClick: this.handleClear
      }, /*#__PURE__*/React.createElement("p", {
        className: "clear-btn-must-haves"
      }, "Clear All"))), /*#__PURE__*/React.createElement("img", {
        src: lineImg,
        className: "line-img",
        alt: "comments"
      }), /*#__PURE__*/React.createElement("div", {
        className: "subheading must-haves"
      }, "We require all projects to have at least 1 must-have tag"), this.renderPriorityBadges())));
    }
  }, {
    key: "renderModalLink",
    value: function renderModalLink() {
      return /*#__PURE__*/React.createElement("i", {
        role: "button",
        tabIndex: 0,
        className: "fa fa-edit modal-link",
        onClick: this.handleShowModal
      }, this.props.formType === 'modal-link' ? 'Edit' : '');
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.formType === 'page') {
        return this.renderContent();
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderModalLink(), this.renderModal());
    }
  }]);
}(Component);
ProjectExpertisePriority.propTypes = {
  formType: PropTypes.string,
  // one of 'page', 'modal-link', 'modal-icon'
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  back: PropTypes.func,
  afterSubmit: PropTypes.func,
  getProjectDetails: PropTypes.func.isRequired,
  backButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  suggestedTagLabels: PropTypes.shape({})
};
ProjectExpertisePriority.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  back: function back() {},
  afterSubmit: function afterSubmit() {},
  backButtonText: 'Back',
  submitButtonText: 'Next',
  suggestedTagLabels: undefined
};
export default ProjectExpertisePriority;